export const quickAnswer =
  '这里集中整理现有 Secret Hideout 的直接答案。每页先给密码、顺序或开关状态，再补充位置和常见卡点。';

## 密码型与操作型谜题

Urban Fresh 和公园 Atlantis 使用收银机密码；市中心餐厅与健身房需要按顺序操作物件。洗衣店和美术馆则重点检查最终开关或灯光状态。先分清谜题类型，避免把同名地点的答案混用。

## 隐藏墙打不开怎么查

回到入口确认观察方向，再核对每个机器标签。答案卡片用于快速定位，详情页提供顺序、示意图与排查步骤。完成后进入隐藏房间，检查其中的升级物品。
